import { FC, useEffect, useState } from "react";

import { Box, IconButton, Typography, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { Colors } from "../../../../configs";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { cloneDeep } from "lodash";
import { CartSliceAction } from "../../../../redux/slice/cartSlice";
import { updateCartSessionItem } from "../../../../redux/actions/cartAction";
import { CustomTextBox } from "../../../atoms";

export interface ICartQtyHandlerSectionProps {}
const CartQtyHandlerSection: FC<ICartQtyHandlerSectionProps> = () => {
  const { selectedCartItem } = useAppSelector((state) => state.cart);
  const dispatch = useAppDispatch();
  const disabled = selectedCartItem === null;

  const doArithmatic = (value: number) => {
    const temItem = cloneDeep(selectedCartItem);
    if (temItem) {
      temItem.qty = value;
      dispatch(updateCartSessionItem({ cartItem: temItem }));
    }
  };

  const handleCountIncrement = () => {
    const temItem = cloneDeep(selectedCartItem);
    if (temItem) {
      temItem.qty = temItem.qty + 1;
      doArithmatic(temItem.qty);
    }
  };
  const handleCountDecrement = () => {
    const temItem = cloneDeep(selectedCartItem);
    if (temItem) {
      temItem.qty = temItem.qty - 1;
      doArithmatic(temItem.qty);
    }
  };
  const handleEditCount = (num: string) => {
    const parsedNum = parseInt(num);
    if (isNaN(parsedNum) || parsedNum < 0) {
      doArithmatic(1);
    } else {
      doArithmatic(parsedNum);
    }
  };
  const handleDefocus = () => {
    if (selectedCartItem?.qty == 0) {
      doArithmatic(1);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "1.25rem",
        background: Colors.WHITE,
        boxShadow: "0 0.2rem 0.85rem rgba(0,0,0,0.07)",
        border: "1px solid #EFEFEF",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "3.21428571rem",
          padding: "0.71rem 2.85714286rem 0.71rem 2.85714286rem",
        }}
      >
        <Typography variant="h5">Count</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "1.07142857rem",
            alignItems: "center",
          }}
        >
          <IconButton
            sx={{
              borderRadius: "0.85rem 0 0 0.85rem",
              background: Colors.SECONDARY,
              width: "3.35714286rem",
              height: "2.5rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: Colors.WHITE,
              "&:hover": {
                background: `${Colors.SECONDARY} !important`,
              },
            }}
            name="decrement-count"
            onClick={handleCountDecrement}
            disabled={disabled || selectedCartItem.qty === 1}
          >
            <RemoveIcon />
          </IconButton>
          <Box
            sx={{
              borderRadius: "50%",
              width: "3.64rem",
              height: "3.64rem",
              background: Colors.SECONDARY,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: Colors.WHITE,
              outline: "none",
              overflow: "hidden",
            }}
          >
            <CustomTextBox
              type="number"
              value={selectedCartItem?.qty ?? ""}
              onChange={(e) => handleEditCount(e.target.value)}
              onBlur={handleDefocus}
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor: Colors.SECONDARY,
                borderRadius: "50%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
                "& .MuiInputBase-input": {
                  color: Colors.WHITE,
                  textAlign: "center",
                  fontSize: "1.42rem",
                  padding: 0,
                },
                "& fieldset": {
                  border: "none",
                },
              }}
              inputProps={{
                style: {
                  textAlign: "center",
                },
              }}
            />
          </Box>
          <IconButton
            sx={{
              borderRadius: "0 0.85rem 0.85rem 0",
              background: Colors.SECONDARY,
              width: "3.35714286rem",
              height: "2.5rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: Colors.WHITE,
              "&:hover": {
                background: `${Colors.SECONDARY} !important`,
              },
            }}
            name="increment-count"
            onClick={handleCountIncrement}
            disabled={disabled}
          >
            <AddIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default CartQtyHandlerSection;
